export default __webpack_public_path__ + "static/media/rakhi10.24e577b8.jpeg";